import request from '#/utils/request';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';
import { keysToSnake } from '#/api/adapters/wireCase';

/**
 * POST `/crm/cost-estimates`：建立（可帶 lines[]；省略或空陣列即零明細）。
 * body 由 `buildCostEstimateCreateBody` 組；不送 line_no／衍生金額。
 */
export async function createCostEstimate(body) {
  const { data: raw } = await request.post('/crm/cost-estimates', keysToSnake(body));
  return parseVer4DetailResponse(raw);
}
